import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { authActions } from "./../../store/reducers/authReducer";


// CSS
import "./DefaultLayout.scss"
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";

const DefaultLayout = () => {

  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setInitialUrl(location));
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate, dispatch, location]);

  return (
    <div className="page-container w-full h-screen">
      <Header />
      <div className="sidebar-container">
        <Sidebar />
        <div className="content w-full p-6">

          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default DefaultLayout;